import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Skeleton, Typography } from '@mui/material';
import { getBrandedUnbrandedCounts, getDynamicTopicCounts } from '../../../../redux/thunks/affinityHubThunk';
import { HighChartDonutChart } from '../../../shared';
import { TOPIC_CHART_OPTIONS, CONTENT_TYPE_CHART_OPTIONS } from './constants';
import { TOPICS } from '../../../../constants';

const TopicAndTypes = (props) => {
    const { } = props; 
    const dispatch = useDispatch();
    const { topic, contentType, } = useSelector(state => state.affinityHub);
    const { chartSeries: topicChartSeries, isLoading: isTopicLoading, topRatedTopic, topRatedCount } = topic;
    const { chartSeries: contentTypeChartSeries, isLoading: isContentTypeLoading, branded, unbranded } = contentType;

    useEffect(() => {
        dispatch(getBrandedUnbrandedCounts());
        dispatch(getDynamicTopicCounts());
    }, [])

    return (
        <Box className="box-sizing-border-box br-16px">
            <Grid container spacing={'24px'} className="flex-row">
                {/*  Topic */}
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Box className="padding-24px bg-gray-50 br-16px">
                        <Grid container spacing={'24px'}>
                            <Grid item xs={12} sm={12} md={12} lg={8} xl={6}>
                            {isTopicLoading ? <Skeleton variant='rectangular' width={'90%'} height={"200px"}/> :
                                <HighChartDonutChart
                                    chartOptions={TOPIC_CHART_OPTIONS}
                                    seriesData={topicChartSeries}
                                />
                            }
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={4} xl={6}>
                                <Box className="flex-column">
                                    <Box className="pb-24px">
                                        <Typography className="text-md-semi-bold gray-900 text-align-left">
                                            Topic
                                        </Typography>
                                    </Box>
                                    <Typography className="text-sm-medium gray-500 pr-8px">
                                        Top Rated Topic:
                                        {isTopicLoading ? <Skeleton variant='rectangular' width={80} height={30}/> :
                                        <Typography className="text-sm-medium primary-600">
                                            {TOPICS[topRatedTopic]}
                                        </Typography>
                                        }
                                    </Typography>
                                    <Box className="pt-8px">
                                        {isTopicLoading ? <Skeleton variant='rectangular' width={50} height={30}/> :
                                            <Typography className="display-sm-semi-bold gray-900">
                                                {topRatedCount + '%'}
                                            </Typography>
                                        }
                                    </Box>
                                </Box>
                                
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

                {/* Types */}
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Box className="padding-24px bg-gray-50 br-16px">
                        <Grid container spacing={'24px'}>
                            <Grid item xs={12} sm={12} md={12} lg={7} xl={6}>
                            {isContentTypeLoading ? <Skeleton variant='rectangular' width={"90%"} height={"200px"}/> :
                                <HighChartDonutChart
                                    chartOptions={CONTENT_TYPE_CHART_OPTIONS}
                                    seriesData={contentTypeChartSeries}
                                />
                            }
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={5} xl={6}>
                                <Box className="flex-column gap-16">
                                    <Box className="pb-24px">
                                        <Typography className="text-md-semi-bold gray-900 text-align-left">
                                            Content Type
                                        </Typography>
                                    </Box>
                                    <Box className="flex-row justify-content-between">
                                        <Box className="flex-column">
                                            <Typography className="text-xs-semi-bold gray-500 pb-8px">
                                                Branded
                                            </Typography>
                                            {isContentTypeLoading ? <Skeleton variant='rectangular' width={80} height={30} /> :
                                            <Typography className="display-sm-semi-bold gray-900">
                                                {branded}
                                            </Typography>
                                            }
                                        </Box>
                                        <Box className="flex-column">
                                            <Typography className="text-xs-semi-bold gray-500 pb-8px">
                                                Unbranded
                                            </Typography>
                                            {isContentTypeLoading ? <Skeleton variant='rectangular' width={80} height={30} /> :
                                            <Typography className="display-sm-semi-bold gray-900">
                                                {unbranded}
                                            </Typography>
                                            }
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default TopicAndTypes;
